import { render } from "./SignUpQuotite.vue?vue&type=template&id=678c536d&scoped=true&ts=true"
import script from "./SignUpQuotite.vue?vue&type=script&lang=ts"
export * from "./SignUpQuotite.vue?vue&type=script&lang=ts"

import "./SignUpQuotite.vue?vue&type=style&index=0&id=678c536d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678c536d"]])

export default __exports__